import { useTranslation } from "react-i18next";
import { LangConstant } from "@/const";
import { ResponseDeviceType } from "@/types/service";
import { GridColDef } from "@/components/common/AppTable/AppTable";

const useDeviceColumn = () => {
  const { t: getLabel } = useTranslation(LangConstant.NS_DEVICE);

  const columnList: GridColDef<ResponseDeviceType>[] = [
    {
      field: "ipAddress",
      headerName: getLabel("OBJ_DEVICE_TABLE_COL.ipAddress"),
      align: "center",
    },
    {
      field: "name",
      headerName: getLabel("OBJ_DEVICE_TABLE_COL.name"),
      align: "center",
    },
    {
      field: "source",
      headerName: getLabel("OBJ_DEVICE_TABLE_COL.source"),
      align: "center",
      render: (cell: ResponseDeviceType) => {
        return cell.internalF ? getLabel("OBJ_SOURCE.wan") : getLabel("OBJ_SOURCE.internet");
      },
    },
    {
      field: "email",
      headerName: getLabel("OBJ_DEVICE_TABLE_COL.email"),
      align: "center",
    },
  ];

  return {
    columnList,
  };
};

export default useDeviceColumn;
